'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _styles = require('@material-ui/core/styles');
var _constants = require('../../../rules/src/constants');
var _utils = require('../utils');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var legendFont = (0, _utils.getFontFromTheme)(['axisLegend'])(theme);
  return {
    xLegend: legendFont,
    yLegend: (0, _extends3.default)({}, legendFont, {
      left: 10,
      position: 'absolute',
      zIndex: 1
    })
  };
});
var getAxisLabel = function getAxisLabel(axis) {
  return R.pipe(R.propOr([], 'series'), R.head, R.when(R.isNil, R.always({})), R.path(['dimensionValues', axis, 'name']));
};
var AxisLegend = function AxisLegend(_ref) {
  var axis = _ref.axis,
    data = _ref.data,
    type = _ref.type;
  var classes = useStyles();
  if (!R.equals(_constants.SCATTER, type)) return null;
  switch (axis) {
    case 'x':
      return _react2.default.createElement('span', {
        className: classes.xLegend
      }, "\u2192 ", getAxisLabel('x')(data));
    case 'y':
      return _react2.default.createElement('span', {
        className: classes.yLegend
      }, "\u2191 ", getAxisLabel('y')(data));
    default:
      return null;
  }
};
AxisLegend.propTypes = {
  axis: _propTypes2.default.string.isRequired,
  data: _propTypes2.default.object.isRequired,
  type: _propTypes2.default.string.isRequired
};
exports.default = AxisLegend;